import React from "react";
import { Form, Input, Select, Row, Col } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const DoctorForm = ({ form, initialFormData }) => {
  const { t } = useTranslation();
  const isDisabled = !!initialFormData;

  return (
    <Form form={form} layout="vertical" initialValues={initialFormData}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="salutation"
            label={t("doctor.salutation")}
            rules={[
              {
                required: true,
                message: t("validation.salutationRequired"),
              },
            ]}
          >
            <Select placeholder="Select a salutation">
              <Option value="Mr.">Mr.</Option>
              <Option value="Miss.">Miss.</Option>
              <Option value="Mrs.">Mrs.</Option>
              <Option value="Ms.">Ms.</Option>
              <Option value="Dr.">Dr.</Option>
              <Option value="Prof.">Prof.</Option>
              <Option value="A/Prof.">A/Prof.</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="first_name"
            label={t("doctor.firstName")}
           
            rules={[
              {
                required: true,
                message: t("validation.firstNameRequired"),
              },
            ]}
          >
            <Input  placeholder={t("doctor.firstName")}/>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="last_name"
            label={t("doctor.lastName")}
            rules={[
              {
                required: true,
                message: t("validation.lastNameRequired"),
              },
            ]}
          >
            <Input  placeholder={t("doctor.lastName")}/>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          <Form.Item
            name="phone_number"
            label={t("doctor.phoneNumber")}
            rules={[
              {
                message: t("validation.phoneNumberRequired"),
              },
            ]}
          >
            <Input  placeholder={t("doctor.phoneNumber")}/>
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={12}>
          <Form.Item
            name="email_address"
            label={t("doctor.emailAddress")}
            rules={[
              {
                required: true,
                message: t("validation.emailAddressRequired"),
              },
            ]}
          >
            <Input
              disabled={isDisabled}
               placeholder={t("doctor.emailAddress")}
              style={{
                backgroundColor: isDisabled && "#e8e8e8",
                color: isDisabled && "black",
                cursor: isDisabled && "not-allowed",
                textTransform: "lowercase",
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      {!initialFormData && (
        <Row>
          <Col span={10}>
            <Form.Item
              name="company_id"
              label={t("doctor.companyId")}
              rules={[
                {
                  required: true,
                  message: t("validation.companyIdRequired"),
                },
              ]}
            >
              <Input  placeholder={t("doctor.companyId")} />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={12}>
            <Form.Item
              name="password"
              label={t("doctor.password")}
              rules={[
                {
                  required: true,
                  message: t("validation.passwordRequired"),
                },
              ]}
            >
              <Input.Password placeholder={t("doctor.password")} />
            </Form.Item>
          </Col>
        </Row>
      )}

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="gender"
            label={t("doctor.gender")}
            rules={[
              {
                required: true,
                message: t("validation.genderRequired"),
              },
            ]}
          >
            <Select placeholder={t("doctor.gender")}>
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Unspecified">Unspecified</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label={t("doctor.dateOfBirth")}
            rules={[
              {
                required: true,
                message: t("validation.dateOfBirthRequired"),
              },
            ]}
          >
            <Input type="date" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="clinic"
            label={t("doctor.clinic")}
            rules={[
              {
                required: true,
                message: t("validation.clinicRequired"),
              },
            ]}
          >
            <Input  placeholder={t("doctor.clinic")} />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            name="professional_profile"
            label={t("doctor.professionalProfile")}
          >
            <Input.TextArea  placeholder={t("doctor.professionalProfile")}/>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="medical_registration"
            label={t("doctor.medicalRegistration")}
          >
            <Input.TextArea placeholder={t("doctor.medicalRegistration")} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="specialties"
            label={t("doctor.specialties")}
          >
            <Input.TextArea  placeholder={t("doctor.specialties")} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="qualifications"
            label={t("doctor.qualifications")}
          >
            <Input.TextArea placeholder={t("doctor.qualifications")} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DoctorForm;
